export const engagementGetProductRecommenderProperties = "/engagement/get_product_recommender_properties";
